// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3l6bQ","content":"styles_content__2nMxH"};